module.exports = __webpack_public_path__ + "img/dsh3.444c0694.jpg";